import React, { useEffect } from 'react';
import useApp from 'hooks/useApp'
import { Button } from 'components'
import styles from './index.module.css'

const CareerResultError3 = () => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="flex_1 padding pt_10">
				<div className={styles["error-box"]}>
					<div>
						수집에 실패한 정보가 있네요.<br />한 번에 다시 수집할 수 있어요!
					</div>
				</div>

				<h3 className="mt_30">소득정보</h3>
				<div className={`${styles["l-title"]} mt_30`} style={{ fontWeight: 300 }}>
					올해 소득은 과거 대비<br />변동 내역을 알 수 없어요.
				</div>
				<div className={`${styles["amount-graph"]} mt_30 pt_20 px_40`}>
					<ul>
						<li>
							<div>
								<div className={styles.bar}>
									<span style={{ height: 0 }}></span>
								</div>
								<p>2019</p>
							</div>
						</li>
						<li>
							<div className={styles.bar}>
								<span style={{ height: 0 }}></span>
							</div>
							<p>2020</p>
						</li>
						<li>
							<div className={`${styles.bar} ${styles.recent}`}>
								<span style={{ height: "100%" }}>
									<span>3,500만원</span>
								</span>
							</div>
							<p>2021</p>
						</li>
					</ul>
				</div>

				<Button className="btn btn--big btn-more mt_40">+ 더보기</Button>
			</div>
			<div className="flex-shrink_0 padding">
				<div className={`${styles["life-guide-banner"]} ${styles["life-banner01"]}`}>
					<div className="pl_100">
						<span>궁금했던 회사가 있다면?</span>
						<p className="mt_5">사업자번호 입력만으로<br />기본정보부터 재무정보까지!</p>
					</div>
					<div className={styles.object} />
				</div>
			</div>
		</div>
	)
}

export default CareerResultError3